module.exports = __webpack_public_path__ + "static/media/paly.2a8f2a9b.svg";